import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock';

const $ = jQuery;

const initOffcanvasToggling = () => {
  const $offcanvasTogglerButton = $('[data-offcanvas-toggler]');
  const $mainNav = $('#nav-header');

  $offcanvasTogglerButton.on('click', function () {
    const offcanvasSelector = $(this).attr('data-target');
    const $offcanvasElement = $(offcanvasSelector);
    $offcanvasElement.toggleClass('offcanvas--show');

    const isHidden = !$offcanvasElement.hasClass('offcanvas--show');
    $offcanvasElement.attr('aria-hidden', isHidden);
    $(this).attr('aria-expanded', !isHidden);

    const offcanvas = document.querySelector(offcanvasSelector).querySelector('.offcanvas__wrapper');

    isHidden ? enableBodyScroll(offcanvas) : disableBodyScroll(offcanvas);

    $mainNav.toggleClass('navbar--offcanvas');
  });
};

const initProgressBullet = () => {
  document.addEventListener('DOMContentLoaded', function () {
    const bullets = document.querySelectorAll('.n2-bullet');

    // Add progress element to each navigation bullet
    bullets.forEach(function (bullet) {
      // Check if a .progress element already exists
      if (!bullet.querySelector('.progress')) {
        const progress = document.createElement('div');
        progress.classList.add('progress');
        bullet.appendChild(progress);
      }
    });

    // Function to reset and start the progress animation
    function startProgress (bullet) {
      const progress = bullet.querySelector('.progress');
      if (progress) {
        // Reset width
        progress.style.transition = 'none';
        progress.style.width = '0%';

        // Force reflow to restart the animation
        void progress.offsetWidth;

        // Set transition and width to start the animation
        progress.style.transition = 'width 5s linear';
        progress.style.width = '100%';
      }
    }

    // MutationObserver to listen for class changes on navigation bullets
    const observer = new MutationObserver(function (mutationsList) {
      mutationsList.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const bullet = mutation.target;
          if (bullet.classList.contains('n2-active')) {
            // Start the progress animation
            startProgress(bullet);
          } else {
            // Optionally: Reset progress when the bullet is no longer active
            const progress = bullet.querySelector('.progress');
            if (progress) {
              progress.style.transition = 'none';
              progress.style.width = '0%';
            }
          }
        }
      });
    });

    // Configuration for the MutationObserver
    const config = { attributes: true, childList: false, subtree: false };

    // Initialize the observer for each navigation bullet
    bullets.forEach(function (bullet) {
      observer.observe(bullet, config);
    });

    // Optionally: Disconnect the observer before the page unloads
    window.addEventListener('beforeunload', function () {
      observer.disconnect();
    });

    // Initially start the progress for any bullet that is already active
    bullets.forEach(function (bullet) {
      if (bullet.classList.contains('n2-active')) {
        startProgress(bullet);
      }
    });
  });
};

export { initOffcanvasToggling, initProgressBullet };
